import React from "react";
import styled from "styled-components";

import { mediaMin, palette } from "../ui-components";
import { Bar, Restaurant, Store, Other } from "../icons";

const Legend = ({ className }) => {
  return (
    <Wrapper className={className}>
      <List>
        <Item>
          <Restaurant /> Restaurants
        </Item>
        <Item>
          <Bar /> Bars
        </Item>
        <Item>
          <Store /> Stores
        </Item>
        <Item>
          <Other /> Other
        </Item>
      </List>
    </Wrapper>
  );
};

export { Legend };

const Wrapper = styled.div`
  position: absolute;
  top: 40px;
  right: calc(50% - 160px);
  z-index: 2;
  width: auto;

  ${mediaMin.laptop`
    top: 10px;
    right: calc(50% - 500px);
  `}
`;

const List = styled.ul`
  margin: 0;
  padding: 0 5px;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${palette.pureWhite};
  border-radius: 20px;
  border: ${({ borderColor }) => `2px solid ${borderColor}`};
  color: ${({ fontColor }) => fontColor};
`;

const Item = styled.li`
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  padding: 0 5px;

  svg {
    vertical-align: middle;
    width: 15px;
    margin-top: -2px;
    margin-right: 5px;
  }
`;
